<div class="globalSearch">
  <div class="search-field-header">
   <span *ngFor="let search of searchTags | slice:0:3; let i = index"
         class="label post-tag remove">{{search.displayName}}:{{search.value}}
     <span class="pointer rem-tag">
       <i (click)="removeSearchTag(search, i)" class="icon ion-close-round tag-remove"></i>
     </span>
   </span>
    <div (click)="toggle($event)" class="pointer"
         style="border: 1px solid #D0D5DD;border-radius: 4px;padding: 10px 14px;">
      <span *ngIf="searchTags.length > 3" style="font-size: 25px;margin:0 5px;">...</span>
      <img src="./images/tpiq-icons/SVG/filter.svg"> Filters
    </div>
  </div>
</div>

<div *ngIf="reveal['search']">
  <div [ngClass]="{'tpiq-reveal': reveal['search']}" class="reveal-overlay">
    <div [ngClass]="{'tpiq-reveal': reveal['search']}" class="reveal tax-strategy-reveal"
         style="width: 50% !important;overflow: initial;">
      <div style="height: 50px; padding: 15px; color: #333333;">
        <span class="float-left">Search</span>
        <span (click)="hideReveal('search')" class="float-right pointer">X</span>
      </div>
      <div style="padding: 0 15px;">
        <hr style="margin: 0;"/>
      </div>
      <div class="body reveal-publish">
        <div class="row row-padding-reveal">
          <div class="small-6 medium-10">
            <div class="row">
              <div class="small-4 medium-3 columns">
                <label class="label-name label-top">Has words</label>
              </div>
              <div class="small-4 medium-7 columns">
                <label>
                  <input #searchText [(ngModel)]="searchModel.search" class="search-words" placeholder="Search"
                         style="font-size: 16px;width: 95%" type="text">
                </label>
              </div>
            </div>
          </div>
          <div class="small-6 medium-6"></div>
        </div>
        <div class="row">
          <div class="small-4 medium-12 columns text-right">
            <button (click)="advanceTasksSearch()" class="button small post-button" data-close type="submit">Search
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
